import { colorsSets } from '@similarweb/styles';

export const SCALE_RATIO_THRESHOLD = 40;
export const CHART_COLORS = colorsSets.c.toArray();
export const CHART_TYPES = {
  AREA: 'area',
  LINE: 'line',
  BUBBLE: 'bubble',
  COLUMN: 'column',
  VENN: 'venn',
  PIE: 'pie',
  SCATTER: 'scatter',
} as const;
